export default {
  groupName: 'adpi-category-tech',
  appName: 'Tech Category',
  baseRoute: '/dashboard/adpi-category-tech',
  label: 'Ad Effect Tech Devices Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Ad Effect Tech Devices Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTech/config/main.js